module.exports = __webpack_public_path__ + "img/0499e6_5377158f450a48baa42bc10040530a26_mv2.1b473e08.webp";